import React, { useState } from 'react'

import {
  Grid, Popover, Button, Checkbox, Toolbar, AppBar, IconButton, Typography, Paper, FormControl,
  FormControlLabel, Input, InputAdornment, TextField
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import { BaseToast } from '../../tools/Toast'

import log from 'loglevel'

import ClearIcon from '@material-ui/icons/Clear'

import { ValidateUrl } from '../../../../utils'

const StyledCheckBox = withStyles({
  root: {
    color: '#A4D164',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const WhitelistNew = (props) => {
  const {
    classes, whitelistsInfo, onBackTrack, onTrigger, site, description, keyboard, application, type,
    confirmAnchorEl = null, setConfirmAnchorEl = () => {}
  } = props

  // Confirmation popover handlers
  const handleConfirmPopover = (e) => {
    setConfirmAnchorEl(e.currentTarget)
  }
  const handleConfirmPopClose = () => {
    setConfirmAnchorEl(null)
  }
  const openConfirmPopover = Boolean(confirmAnchorEl)

  const [newSite, setNewSite] = useState(site)
  const [newDescription, setNewDescription] = useState(description)

  const [newKeyboard, setNewKeyboard] = useState(keyboard)
  const [newApplication, setNewApplication] = useState(application)

  const handleClearSearch = () => {
    setNewSite('')
  }

  const toggleKeyboard = () => {
    if (newApplication === false || 0) {
      BaseToast('info', 'Phrase must have at least one source selected.')
    } else {
      log.info('changed to keyboard')
      setNewKeyboard(!newKeyboard)
    }
  }

  const toggleApplication = () => {
    if (newKeyboard === false || 0) {
      BaseToast('info', 'Phrase must have at least one source selected.')
    } else {
      setNewApplication(!newApplication)
    }
  }
  return (
    <>
      <Paper elevation={2} className={classes.modalContainer}>
        <Grid container direction='column' justify='center' className='w-100 mx-auto h-100 my-auto' spacing={4}>

          <Grid container item className='pt-0 px-0'>
            <AppBar position='relative' className={classes.whitelistAppbar}>
              <Toolbar className='my-2'>
                <Typography
                  component='h5'
                  variant='h5'
                  className='mx-auto font-weight-bold'
                >
                  {type === 'list' ? 'New' : 'Edit'} Whitelist Site For {whitelistsInfo.unitName}
                </Typography>
              </Toolbar>
            </AppBar>
          </Grid>

          <Grid item container direction='column' className='px-4'>
            <FormControl className={classes.siteInput}>
              <Input
                value={newSite}
                onChange={(e) => setNewSite(e.target.value)}
                id='site-input'
                placeholder='https://www.google.com'
                name='siteInput'
                type='url'
                classes={{
                  input: classes.encryptForm
                }}
                error={!ValidateUrl(newSite)}
                disabled={type === 'edit'}
                endAdornment={newSite !== '' && type !== 'edit' &&
                  (
                    <InputAdornment position='start'>
                      <IconButton onClick={handleClearSearch}>
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  )}
              />
            </FormControl>
          </Grid>

          <Grid item container className='px-4'>
            <TextField
              multiline
              rows={2}
              rowsMax={6}
              value={newDescription}
              label='Site Description'
              onChange={(e) => setNewDescription(e.target.value)}
              className={classes.descriptionInput}
              variant='outlined'
              required
            />
          </Grid>

          <Grid item container direction='row' className='px-4'>
            <Grid item container xs={6} justify='center' direction='row'>
              <FormControlLabel
                value={newKeyboard}
                control={
                  <StyledCheckBox
                    checked={newKeyboard}
                    onChange={() => toggleKeyboard()}
                  />
                }
                label={<Typography className={classes.toggles}>Keyboard</Typography>}
                labelPlacement='start'
                className='m-0 font-weight-bold'
              />
            </Grid>

            <Grid item container xs={6} justify='center' direction='row'>
              <FormControlLabel
                value={newApplication}
                control={
                  <StyledCheckBox
                    checked={newApplication}
                    onChange={() => toggleApplication()}
                  />
                }
                label={<Typography className={classes.toggles}>Application</Typography>}
                labelPlacement='start'
                className='m-0'
              />
            </Grid>
          </Grid>

          <Grid item container justify='center' direction='row' spacing={4} className='px-4 w-100 mx-auto my-auto pt-0'>
            <Grid item>
              <Button
                variant='contained'
                className={`${classes.greenBtn}`}
                onClick={(e) => { e.preventDefault(); onBackTrack() }}
              >
                Close
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant='contained'
                className={`${classes.blueBtn}`}
                onClick={(e) => { e.stopPropagation(); handleConfirmPopover(e) }}
              >
                Save
              </Button>
            </Grid>
          </Grid>

        </Grid>
      </Paper>
      {/* CONFIRMATION POPOVER FOR NEW WHITELIST ITEM (START) */}
      <Popover
        id={openConfirmPopover ? 'confirm-popover' : undefined}
        open={openConfirmPopover}
        anchorEl={confirmAnchorEl}
        onClose={handleConfirmPopClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        PaperProps={
          {
            style: {
              maxWidth: '50%'
            }
          }
        }
      >
        <Grid container direction='column' style={{ padding: '1em' }}>
          <Grid item>
            <Typography gutterBottom style={{ fontWeight: 'bold', fontSize: '1.2em' }}>
              Warning:
            </Typography>
            <Typography>
              Whitelisted websites are excluded from retrieving captures while users are browsing the whitelisted website.
              Ensure the website entry is correct and that you understand the implications of making this change at the selected OU and sub OUs.
            </Typography>
          </Grid>

          <Grid item container direction='row' justify='flex-end' alignItems='center' style={{ marginTop: '.5em' }}>
            <Button
              onClick={handleConfirmPopClose}
              style={{ marginRight: '.3em', textTransform: 'none', fontWeight: '600' }}
            >
              Cancel
            </Button>

            <Button
              variant='contained'
              className={classes.errorButton}
              onClick={(e) => { e.preventDefault(); onTrigger(newSite, newDescription, newKeyboard, newApplication) }}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </Popover>
      {/* CONFIRMATION POPOVER FOR NEW WHITELIST ITEM (END) */}
    </>
  )
}

export default WhitelistNew
